export function createFormData(data , ignoreNulls = true){
    let ret = new FormData();

    for(let d in data){
        if (typeof data[d] != 'boolean' && !data[d] && data[d] !== 0  && (typeof data[0] != 'object' ?? !data[0].length) && ignoreNulls) continue;

        if (typeof data[d] == 'object'){
            if (isFormatFile(data[d])){
                ret.append(d , data[d])
            }else{
                insertArrayToFormData(ret , data[d], ignoreNulls , d)
            }
        }else{
            ret.append(d , data[d])
        }
    }

    return ret;
}

export function insertArrayToFormData(formdata , data, ignoreNulls = true, name=""){
    for(let d in data){
        if (typeof data[d] != 'boolean' && !data[d] && data[d] !== 0  && (typeof data[0] != 'object' ?? !data[0].length) && ignoreNulls) continue;
        let key = name + `[${d}]`


        if (typeof data[d] == 'object'){
            if (isFormatFile(data[d])){
                formdata.append(key , data[d])
            }else{
                insertArrayToFormData(formdata , data[d], ignoreNulls , key)
            }
        }else{
            formdata.append(key , data[d])
        }

    }
}

//UTILITIES FUNCTIONS
function isFormatFile(d){
    return d instanceof File;


}

export default {
    insertArrayToFormData,
    createFormData
}